import { getActionsForSubMetric } from 'helpers/submetrics/getActionsForSubMetric';
import { useMemo } from 'react';
import useActionPlanData from 'services/actionPlan/actionPlanData';
import { ActionPlanItem } from 'types/ActionPlan';
import { useMainFindings } from 'views/Results/Summary/SummaryCards/NoteCard/useMainFindings';

export default function useMainFindingsWithActions(currentKitId?: string) {
  const { data: mainFindingsData, isPending } = useMainFindings(currentKitId);
  const { data: allActions } = useActionPlanData({ kitId: currentKitId });

  const mainFindings = mainFindingsData?.mainFindings || [];

  const findingsWithActions = useMemo(() => {
    if (!mainFindings.length || !allActions?.length) return [];

    return mainFindings.map(finding => {
      const relatedActions: ActionPlanItem[] = finding.sample_health_id
        ? getActionsForSubMetric(allActions, finding.sample_health_id)
        : [];

      return {
        metric: {
          sample_health_id: finding.sample_health_id,
          user_value: finding.user_value,
          user_string: finding.user_string,
          evaluation_color: finding.evaluation_color,
          gvh: finding.gvh,
        },
        relatedActions,
      };
    });
  }, [mainFindings, allActions]);

  return { findingsWithActions, mainFindings, isPending };
}
